import * as yup from 'yup';
import { SplitScreenPromo } from '../../components';
import { richTextFromCMSSchema } from '../schemas';
import { schema as heading } from './heading';
import { schema as imageSchema } from './image';

export const component = SplitScreenPromo;

export const schema = yup
  .object({
    title: heading,
    contentBgColor: yup.string().nullable(),
    buttonText: yup.string().nullable(),
    urlTarget: yup.string().nullable(),
    fontColor: yup.string().nullable(),
    imageBgColor: yup.string().nullable(),
    imageFirst: yup.object().required(),
    children: richTextFromCMSSchema,
    image: imageSchema.nullable(),
  })
  .transform(value => ({
    title: value.title[0],
    contentBgColor: value.content_background_color,
    buttonText: value.button_text,
    urlTarget: value.url_target.url,
    fontColor: value.font_color,
    imageBgColor: value.image_background_color,
    image: value.image?.[0] || null,
    children: value.body,
    imageFirst: {
      mobile: value.image_first_mobile,
      desktop: value.image_first_desktop,
    },
  }));
